import { render, staticRenderFns } from "./StackService.vue?vue&type=template&id=48a4c472&scoped=true&"
import script from "./StackService.vue?vue&type=script&lang=js&"
export * from "./StackService.vue?vue&type=script&lang=js&"
import style0 from "./StackService.vue?vue&type=style&index=0&id=48a4c472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a4c472",
  null
  
)

export default component.exports